import BankDetails from './BankDetails'
import Button from './Button'
import Classes from './Classes'
import ClassList from './ClassList'
import Confirm from './Confirm'
import Invoice from './Invoice'
import Type from './Type'

export { BankDetails, Button, Classes, ClassList, Confirm, Invoice, Type }



//////////////////
// WEBPACK FOOTER
// ./src/components/competitions/registration/index.js
// module id = 920
// module chunks = 1